import i18nGlobal from '@/i18ns/i18n';
const i18n = i18nGlobal.global;
import api from '@/apis/report/voucherReportPrintAPI';
import commonFn from '@/commons/commonFunction';
import RefType from '@/commons/wildcards/constants/RefType.js';

export const printVoucherMenu = {
  data() {
    return {
      /**
       * Danh sách các mẫu in
       */
      printMenu: [],
    };
  },
  computed: {},
  methods: {
    /**
     * Load phiếu chứng từ in theo reftype
     * ignoreDefaultItem: Nếu giá trị này bằng true thì bỏ qua các giá trị đc đẩy thêm vào
     * dqvinh edited 30/11/2023
     */
    loadPrintMenu(refType, ignoreDefaultItem) {
      const me = this,
        fnInit = function (data) {
          //xử lý text hiển thị
          for (let i = 0; i < data.length; i++) {
            const item = data[i];

            item.text = item.report_name = commonFn.getReportName(item.report_id, item.report_name);
          }
          me.printMenu = me.customDataPrintMenu(data);
        },
        voucherHasPrintBatch = [
          me.$ms.constant.RefType.BUTransfer,
          me.$ms.constant.RefType.BUTransferDeposit,
          me.$ms.constant.RefType.BUTransferPurchase,
          me.$ms.constant.RefType.BUTransferVendorPayment,
          me.$ms.constant.RefType.BUTransferSalary,
          me.$ms.constant.RefType.BUTransferFixedAsset,
          me.$ms.constant.RefType.BUTreasuryFundTransferSalary,
          me.$ms.constant.RefType.BUTreasuryFundTransferInsurancePayment,
          me.$ms.constant.RefType.BUPlanWithdrawDeposit,
          me.$ms.constant.RefType.BUPlanWithdrawCash,
          me.$ms.constant.RefType.BUPlanWithdrawTransfer,
          me.$ms.constant.RefType.BUPlanWithdrawSalaryTransfer,
          me.$ms.constant.RefType.BUPlanReceipt,
          me.$ms.constant.RefType.BUPlanSupplement,
          me.$ms.constant.RefType.BUPlanCancel,
          me.$ms.constant.RefType.BUPlanAdjustment,
          me.$ms.constant.RefType.BUCommitmentRequest,
          me.$ms.constant.RefType.BUCommitmentAdjustment,
          me.$ms.constant.RefType.CAReceiptSale,
          me.$ms.constant.RefType.CAReceipt,
          me.$ms.constant.RefType.CAReceiptWithdraw,
          me.$ms.constant.RefType.CAReceiptPlanWithdraw,
          me.$ms.constant.RefType.CAPaymentPurchase,
          me.$ms.constant.RefType.CAPaymentVendor,
          me.$ms.constant.RefType.CAPaymentSalary,
          me.$ms.constant.RefType.CAPayment,
          me.$ms.constant.RefType.CAPaymentDeposit,
          me.$ms.constant.RefType.CAPaymentFixedAsset,
          me.$ms.constant.RefType.CAReceiptCustomer,
          me.$ms.constant.RefType.CAReceiptFixedAsset,
          me.$ms.constant.RefType.SAReturn,
          me.$ms.constant.RefType.SAInvoice,
          me.$ms.constant.RefType.INTransfer,
          me.$ms.constant.RefType.INAdjustment,
          me.$ms.constant.RefType.INOutward,
          me.$ms.constant.RefType.INInward,
          me.$ms.constant.RefType.BADeposit,
          me.$ms.constant.RefType.BATransferDeposit,
          me.$ms.constant.RefType.BATransferWithdraw,
          me.$ms.constant.RefType.BADepositSale,
          me.$ms.constant.RefType.BADepositCustomer,
          me.$ms.constant.RefType.BAWithdrawVendor,
          me.$ms.constant.RefType.BAWithDrawSalary,
          me.$ms.constant.RefType.BAWithDrawFixedAsset,
          me.$ms.constant.RefType.BABankTransfer,
          me.$ms.constant.RefType.BAWithdrawPurchase,
          me.$ms.constant.RefType.BAWithDraw,
          me.$ms.constant.RefType.GLGeneralVoucher,
          me.$ms.constant.RefType.GLEndYearTransfer,
          me.$ms.constant.RefType.GLBeginningYearTransfer,
          me.$ms.constant.RefType.GLProfitLossTransfer,
          me.$ms.constant.RefType.GLPayrollExpense,
          me.$ms.constant.RefType.GLProvisionalTaxInComeEnterprise,
          me.$ms.constant.RefType.GLFinalTaxInComeEnterprise,
          me.$ms.constant.RefType.GLVoucherSummaryTable,
          me.$ms.constant.RefType.GLPostedVoucher,
          me.$ms.constant.RefType.INInwardFromINAdjustment,
          me.$ms.constant.RefType.INInwardFromINAdjustmentChangeAmount,
          me.$ms.constant.RefType.INOutwardFromINAdjustment,
          me.$ms.constant.RefType.INOutwardFromINAdjustmentChangeAmount,
          me.$ms.constant.RefType.FAIncrement,
          me.$ms.constant.RefType.FADecrement,
          me.$ms.constant.RefType.FAAdjustment,
          me.$ms.constant.RefType.FADepreciation,
          me.$ms.constant.RefType.FADevaluation,
          me.$ms.constant.RefType.FAPurchaseInvoice,
          me.$ms.constant.RefType.FAVoucherDepreciation,
          me.$ms.constant.RefType.FAVoucherIncreament,
          me.$ms.constant.RefType.FAVoucherAdjustment,
          me.$ms.constant.RefType.FAVoucherDepreciate,
          me.$ms.constant.RefType.FAVoucherDecrement,
          me.$ms.constant.RefType.PUInvoice,
          me.$ms.constant.RefType.SASaleInvoice,
          me.$ms.constant.RefType.FASaleInvoice,
          me.$ms.constant.RefType.BADepositFixedAsset,
        ];

      //xử lý cache theo phiên đăng nhập
      let data = me.getCachePrintMenu(refType);
      if (data) {
        let reportShowInMenu = data.filter(x => x.has_view == true && x.is_visible == true);
        if(!ignoreDefaultItem)
        {
          let mergetemplateSetting = reportShowInMenu.find(x => x.report_id == 'MergeTemplateSetting');
          if (!mergetemplateSetting) {
            // Bổ sung thêm phần thiết kết mẫu chứng từ đối với các refType đặc biệt
            // if (refType == RefType.BAWithdraw // Chi tiền gửi
            //   || refType == RefType.BAWithdrawSalary // Chi tiền gửi trả lương
            //   || refType == RefType.BAWithdrawVendor // Chi tiền gửi trả nhà cung cấp
            //   || refType == RefType.BAWithdrawPurchase // Chi tiền gửi mua vật tư hàng hóa
            //   || refType == RefType.BAWithdrawFixedAsset // Chi tiền gửi mua TSCĐ
            //   || refType == RefType.BABankTransfer  // Chuyển tiền nội bộ
            // ) {
            if (
              refType == 157 || // Chi tiền gửi
              refType == 163 || // Chi tiền gửi trả lương
              refType == 160 || // Chi tiền gửi trả nhà cung cấp
              refType == 158 || // Chi tiền gửi mua vật tư hàng hóa
              refType == 159 || // Chi tiền gửi mua TSCĐ
              refType == 162 // Chuyển tiền nội bộ
            ) {
              reportShowInMenu.push({
                input_type_name: 'MergeTemplateSetting',
                report_name: 'Thiết kế mẫu chứng từ',
                is_visible: true,
                has_view: true,
                report_id: 'UNCMauTron',
                report_type_id: 1,
              });
            }

            if (refType == 113) {
              reportShowInMenu.push({
                input_type_name: 'MergeTemplateSetting',
                report_name: 'Thiết kế mẫu chứng từ',
                is_visible: true,
                has_view: true,
                report_id: 'GNTMauTron',
                report_type_id: 2,
              });
            }
          }

          let printBatchOption = reportShowInMenu.find(x => x.report_id == 'PrintBatch');
          if (!printBatchOption && voucherHasPrintBatch.includes(refType)) {
            reportShowInMenu.push({
              input_type_name: 'PrintBatch',
              report_name: 'In theo lô nhiều chứng từ',
              is_visible: true,
              has_view: true,
              report_id: 'PrintBatch',
              ref_type: refType,
            });
          }

          let settingPrintOption = reportShowInMenu.find(x => x.report_id == 'SettingPrint');
          if (!settingPrintOption) {
            reportShowInMenu.push({
              input_type_name: 'SettingPrint',
              report_name: 'Tùy chọn in',
              is_visible: true,
              has_view: true,
              report_id: 'SettingPrint',
              class: [RefType.PASalary].includes(refType) ? 'disabled' : '',
            });
          } else {
            settingPrintOption.class = [RefType.PASalary].includes(refType)
              ? 'disabled'
              : '';
          }
        }

        fnInit(reportShowInMenu);
      } else if (!data) {
        //cache không có thì load dữ liệu từ server
        api
          .getPrintMenu(refType, true)
          .then(res => {
            if (!Array.isArray(res) || res.length === 0) {
              return;
            }
            res.forEach(item => {
              // Bổ sung thông tin allow_batching_print
              item.allow_batch_printing = item.is_allow_batch_printing;
              if (
                (item.is_allow_batch_printing == false || item.is_allow_batch_printing == null) &&
                item.report_id != 'SettingPrint'
              ) {
                const disableOptions = item.disable_options;
                if (disableOptions) {
                  const disableOptionsObject = JSON.parse(disableOptions);
                  disableOptionsObject.allow_batch_printing = true;
                  item.disable_options = JSON.stringify(disableOptionsObject);
                } else {
                  item.disable_options = JSON.stringify({
                    allow_batch_printing: true,
                  });
                }
              }
            });
            //đẩy vào cache
            me.setCachePrintMenu(refType, res);

            let reportShowInMenu = res.filter(x => x.has_view == true && x.is_visible == true);
            // Bổ sung option Tùy chọn in
            // Bổ sung thêm phần thiết kết mẫu chứng từ đối với các refType đặc biệt
            // if (refType == RefType.BAWithdraw // Chi tiền gửi
            //   || refType == RefType.BAWithdrawSalary // Chi tiền gửi trả lương
            //   || refType == RefType.BAWithdrawVendor // Chi tiền gửi trả nhà cung cấp
            //   || refType == RefType.BAWithdrawPurchase // Chi tiền gửi mua vật tư hàng hóa
            //   || refType == RefType.BAWithdrawFixedAsset // Chi tiền gửi mua TSCĐ
            //   || refType == RefType.BABankTransfer  // Chuyển tiền nội bộ
            // ) {

            if (!ignoreDefaultItem) {
              if (
                refType == 157 || // Chi tiền gửi
                refType == 163 || // Chi tiền gửi trả lương
                refType == 160 || // Chi tiền gửi trả nhà cung cấp
                refType == 158 || // Chi tiền gửi mua vật tư hàng hóa
                refType == 159 || // Chi tiền gửi mua TSCĐ
                refType == 162 // Chuyển tiền nội bộ
              ) {
                reportShowInMenu.push({
                  input_type_name: 'MergeTemplateSetting',
                  report_name: 'Thiết kế mẫu chứng từ',
                  is_visible: true,
                  has_view: true,
                  report_id: 'UNCMauTron',
                  report_type: 4,
                  report_type_id: 1,
                });
              }

              if (refType == 113) {
                reportShowInMenu.push({
                  input_type_name: 'MergeTemplateSetting',
                  report_name: 'Thiết kế mẫu chứng từ',
                  is_visible: true,
                  has_view: true,
                  report_id: 'GNTMauTron',
                  report_type: 4,
                  report_type_id: 2,
                });
              }

              if (voucherHasPrintBatch.includes(refType)) {
                reportShowInMenu.push({
                  input_type_name: 'PrintBatch',
                  report_name: 'In theo lô nhiều chứng từ',
                  is_visible: true,
                  has_view: true,
                  report_id: 'PrintBatch',
                  ref_type: refType,
                });
              }

              reportShowInMenu.push({
                input_type_name: 'SettingPrint',
                report_name: 'Tùy chọn in',
                is_visible: true,
                has_view: true,
                report_id: 'SettingPrint',
                class: [RefType.PASalary].includes(refType) ? 'disabled' : '',
              });
            }
            fnInit(reportShowInMenu);
          })
          .catch(err => {
            console.error(err);
          });
      }
    },

    /**
   * ldduy 23.1.2023 clone riêng ra 1 hàm async từ hàm loadPrintMenu phục vụ load menu in lô
   */
  async loadAsyncPrintMenu(refType, ignoreDefaultItem) {
      const me = this,
        fnInit = function (data) {
          //xử lý text hiển thị
          for (let i = 0; i < data.length; i++) {
            const item = data[i];

            item.text = item.report_name = commonFn.getReportName(item.report_id, item.report_name);
          }
          me.printMenu = me.customDataPrintMenu(data);
        },
        voucherHasPrintBatch = [
          me.$ms.constant.RefType.BUTransfer,
          me.$ms.constant.RefType.BUTransferDeposit,
          me.$ms.constant.RefType.BUTransferPurchase,
          me.$ms.constant.RefType.BUTransferVendorPayment,
          me.$ms.constant.RefType.BUTransferSalary,
          me.$ms.constant.RefType.BUTransferFixedAsset,
          me.$ms.constant.RefType.BUTreasuryFundTransferSalary,
          me.$ms.constant.RefType.BUTreasuryFundTransferInsurancePayment,
          me.$ms.constant.RefType.BUPlanWithdrawDeposit,
          me.$ms.constant.RefType.BUPlanWithdrawCash,
          me.$ms.constant.RefType.BUPlanWithdrawTransfer,
          me.$ms.constant.RefType.BUPlanWithdrawSalaryTransfer,
          me.$ms.constant.RefType.BUPlanReceipt,
          me.$ms.constant.RefType.BUPlanSupplement,
          me.$ms.constant.RefType.BUPlanCancel,
          me.$ms.constant.RefType.BUPlanAdjustment,
          me.$ms.constant.RefType.BUCommitmentRequest,
          me.$ms.constant.RefType.BUCommitmentAdjustment,
          me.$ms.constant.RefType.CAReceiptSale,
          me.$ms.constant.RefType.CAReceipt,
          me.$ms.constant.RefType.CAReceiptWithdraw,
          me.$ms.constant.RefType.CAReceiptPlanWithdraw,
          me.$ms.constant.RefType.CAPaymentPurchase,
          me.$ms.constant.RefType.CAPaymentVendor,
          me.$ms.constant.RefType.CAPaymentSalary,
          me.$ms.constant.RefType.CAPayment,
          me.$ms.constant.RefType.CAPaymentDeposit,
          me.$ms.constant.RefType.CAPaymentFixedAsset,
          me.$ms.constant.RefType.CAReceiptCustomer,
          me.$ms.constant.RefType.CAReceiptFixedAsset,
          me.$ms.constant.RefType.SAReturn,
          me.$ms.constant.RefType.SAInvoice,
          me.$ms.constant.RefType.INTransfer,
          me.$ms.constant.RefType.INAdjustment,
          me.$ms.constant.RefType.INOutward,
          me.$ms.constant.RefType.INInward,
          me.$ms.constant.RefType.BADeposit,
          me.$ms.constant.RefType.BATransferDeposit,
          me.$ms.constant.RefType.BATransferWithdraw,
          me.$ms.constant.RefType.BADepositSale,
          me.$ms.constant.RefType.BADepositCustomer,
          me.$ms.constant.RefType.BAWithdrawVendor,
          me.$ms.constant.RefType.BAWithDrawSalary,
          me.$ms.constant.RefType.BAWithDrawFixedAsset,
          me.$ms.constant.RefType.BABankTransfer,
          me.$ms.constant.RefType.BAWithdrawPurchase,
          me.$ms.constant.RefType.BAWithDraw,
          me.$ms.constant.RefType.GLGeneralVoucher,
          me.$ms.constant.RefType.GLEndYearTransfer,
          me.$ms.constant.RefType.GLBeginningYearTransfer,
          me.$ms.constant.RefType.GLProfitLossTransfer,
          me.$ms.constant.RefType.GLPayrollExpense,
          me.$ms.constant.RefType.GLProvisionalTaxInComeEnterprise,
          me.$ms.constant.RefType.GLFinalTaxInComeEnterprise,
          me.$ms.constant.RefType.GLVoucherSummaryTable,
          me.$ms.constant.RefType.GLPostedVoucher,
          me.$ms.constant.RefType.INInwardFromINAdjustment,
          me.$ms.constant.RefType.INInwardFromINAdjustmentChangeAmount,
          me.$ms.constant.RefType.INOutwardFromINAdjustment,
          me.$ms.constant.RefType.INOutwardFromINAdjustmentChangeAmount,
          me.$ms.constant.RefType.FAIncrement,
          me.$ms.constant.RefType.FADecrement,
          me.$ms.constant.RefType.FAAdjustment,
          me.$ms.constant.RefType.FADepreciation,
          me.$ms.constant.RefType.FADevaluation,
          me.$ms.constant.RefType.FAPurchaseInvoice,
          me.$ms.constant.RefType.FAVoucherDepreciation,
          me.$ms.constant.RefType.FAVoucherIncreament,
          me.$ms.constant.RefType.FAVoucherAdjustment,
          me.$ms.constant.RefType.FAVoucherDepreciate,
          me.$ms.constant.RefType.FAVoucherDecrement,
          me.$ms.constant.RefType.PUInvoice,
          me.$ms.constant.RefType.SASaleInvoice,
          me.$ms.constant.RefType.FASaleInvoice,
          me.$ms.constant.RefType.BADepositFixedAsset,
        ];

      //xử lý cache theo phiên đăng nhập
      let data = me.getCachePrintMenu(refType);
      if (data) {
        let reportShowInMenu = data.filter(x => x.has_view == true && x.is_visible == true);
        if(!ignoreDefaultItem)
        {
          let mergetemplateSetting = reportShowInMenu.find(x => x.report_id == 'MergeTemplateSetting');
          if (!mergetemplateSetting) {
            // Bổ sung thêm phần thiết kết mẫu chứng từ đối với các refType đặc biệt
            // if (refType == RefType.BAWithdraw // Chi tiền gửi
            //   || refType == RefType.BAWithdrawSalary // Chi tiền gửi trả lương
            //   || refType == RefType.BAWithdrawVendor // Chi tiền gửi trả nhà cung cấp
            //   || refType == RefType.BAWithdrawPurchase // Chi tiền gửi mua vật tư hàng hóa
            //   || refType == RefType.BAWithdrawFixedAsset // Chi tiền gửi mua TSCĐ
            //   || refType == RefType.BABankTransfer  // Chuyển tiền nội bộ
            // ) {
            if (
              refType == 157 || // Chi tiền gửi
              refType == 163 || // Chi tiền gửi trả lương
              refType == 160 || // Chi tiền gửi trả nhà cung cấp
              refType == 158 || // Chi tiền gửi mua vật tư hàng hóa
              refType == 159 || // Chi tiền gửi mua TSCĐ
              refType == 162 // Chuyển tiền nội bộ
            ) {
              reportShowInMenu.push({
                input_type_name: 'MergeTemplateSetting',
                report_name: 'Thiết kế mẫu chứng từ',
                is_visible: true,
                has_view: true,
                report_id: 'UNCMauTron',
                report_type_id: 1,
              });
            }

            if (refType == 113) {
              reportShowInMenu.push({
                input_type_name: 'MergeTemplateSetting',
                report_name: 'Thiết kế mẫu chứng từ',
                is_visible: true,
                has_view: true,
                report_id: 'GNTMauTron',
                report_type_id: 2,
              });
            }
          }

          let printBatchOption = reportShowInMenu.find(x => x.report_id == 'PrintBatch');
          if (!printBatchOption && voucherHasPrintBatch.includes(refType)) {
            reportShowInMenu.push({
              input_type_name: 'PrintBatch',
              report_name: 'In theo lô nhiều chứng từ',
              is_visible: true,
              has_view: true,
              report_id: 'PrintBatch',
              ref_type: refType,
            });
          }

          let settingPrintOption = reportShowInMenu.find(x => x.report_id == 'SettingPrint');
          if (!settingPrintOption) {
            reportShowInMenu.push({
              input_type_name: 'SettingPrint',
              report_name: 'Tùy chọn in',
              is_visible: true,
              has_view: true,
              report_id: 'SettingPrint',
              class: [RefType.PASalary].includes(refType) ? 'disabled' : '',
            });
          } else {
            settingPrintOption.class = [RefType.PASalary].includes(refType)
              ? 'disabled'
              : '';
          }
        }

        fnInit(reportShowInMenu);
      } else if (!data) {
        //cache không có thì load dữ liệu từ server
        var res = await api.getAsyncPrintMenu(refType, true);
        if (!Array.isArray(res) || res.length === 0) {
              return;
        }
            res.forEach(item => {
              // Bổ sung thông tin allow_batching_print
              item.allow_batch_printing = item.is_allow_batch_printing;
              if (
                (item.is_allow_batch_printing == false || item.is_allow_batch_printing == null) &&
                item.report_id != 'SettingPrint'
              ) {
                const disableOptions = item.disable_options;
                if (disableOptions) {
                  const disableOptionsObject = JSON.parse(disableOptions);
                  disableOptionsObject.allow_batch_printing = true;
                  item.disable_options = JSON.stringify(disableOptionsObject);
                } else {
                  item.disable_options = JSON.stringify({
                    allow_batch_printing: true,
                  });
                }
              }
            });
            //đẩy vào cache
            me.setCachePrintMenu(refType, res);

            let reportShowInMenu = res.filter(x => x.has_view == true && x.is_visible == true);
            // Bổ sung option Tùy chọn in
            // Bổ sung thêm phần thiết kết mẫu chứng từ đối với các refType đặc biệt
            // if (refType == RefType.BAWithdraw // Chi tiền gửi
            //   || refType == RefType.BAWithdrawSalary // Chi tiền gửi trả lương
            //   || refType == RefType.BAWithdrawVendor // Chi tiền gửi trả nhà cung cấp
            //   || refType == RefType.BAWithdrawPurchase // Chi tiền gửi mua vật tư hàng hóa
            //   || refType == RefType.BAWithdrawFixedAsset // Chi tiền gửi mua TSCĐ
            //   || refType == RefType.BABankTransfer  // Chuyển tiền nội bộ
            // ) {

            if (!ignoreDefaultItem) {
              if (
                refType == 157 || // Chi tiền gửi
                refType == 163 || // Chi tiền gửi trả lương
                refType == 160 || // Chi tiền gửi trả nhà cung cấp
                refType == 158 || // Chi tiền gửi mua vật tư hàng hóa
                refType == 159 || // Chi tiền gửi mua TSCĐ
                refType == 162 // Chuyển tiền nội bộ
              ) {
                reportShowInMenu.push({
                  input_type_name: 'MergeTemplateSetting',
                  report_name: 'Thiết kế mẫu chứng từ',
                  is_visible: true,
                  has_view: true,
                  report_id: 'UNCMauTron',
                  report_type: 4,
                  report_type_id: 1,
                });
              }

              if (refType == 113) {
                reportShowInMenu.push({
                  input_type_name: 'MergeTemplateSetting',
                  report_name: 'Thiết kế mẫu chứng từ',
                  is_visible: true,
                  has_view: true,
                  report_id: 'GNTMauTron',
                  report_type: 4,
                  report_type_id: 2,
                });
              }

              if (voucherHasPrintBatch.includes(refType)) {
                reportShowInMenu.push({
                  input_type_name: 'PrintBatch',
                  report_name: 'In theo lô nhiều chứng từ',
                  is_visible: true,
                  has_view: true,
                  report_id: 'PrintBatch',
                  ref_type: refType,
                });
              }

              reportShowInMenu.push({
                input_type_name: 'SettingPrint',
                report_name: 'Tùy chọn in',
                is_visible: true,
                has_view: true,
                report_id: 'SettingPrint',
                class: [RefType.PASalary].includes(refType) ? 'disabled' : '',
              });
            }
            fnInit(reportShowInMenu);
      }
    },

    /**
     * Custom lại danh sách in
     * lttuan1 - 05.07.2023
     */
    customDataPrintMenu(data) {
      return data;
    },

    /**
     * key cache danh sách phiếu in
     * Bổ sung thêm prefix là dataBaseID để phân biệt được các menu giữa các đơn vị
     * Làm hướng này vì hiện tại hướng IndexDB cần async-await ảnh hưởng
     * 28/11/2023
     */
    getPrintMenuCacheKey(refType) {
      let me = this, dbId = me.$store?.state?.context?.Context?.DatabaseId;
      return ['printMenu', refType, dbId].join('');
    },

    /**
     * Đọc menu in từ cache
     * Sẽ cache theo sessionStorage
     */
    getCachePrintMenu(refType) {
      const key = this.getPrintMenuCacheKey(refType);
      let data = commonFn.getSessionStorage(key);
      if (data) {
        return JSON.parse(data);
      }
      return null;
    },
    /**
     * Lưu cache
     */
    setCachePrintMenu(refType, data) {
      const key = this.getPrintMenuCacheKey(refType);
      commonFn.setSessionStorage(key, JSON.stringify(data));
    },
    /**
     * Lấy ra report theo id
     * @param {*} refType 
     * @param {*} reportId 
     * nvtoan2 19/07/2023
     */
    getReportConfig(refType, reportId) {
      if(typeof this.getCachePrintMenu === 'function') {
        let lstReport = this.getCachePrintMenu(refType);

        return lstReport?.find(x => x.report_id == reportId);
      }
      
      return null;
    }
  },
};
